// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_8i7","colMin":"styles_colMin__3H8fo"};